exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".recipe-modal-container.ui.modal > .header {\n  display: flex;\n  justify-content: flex-end;\n  background: #7cbbe1;\n  color: #ffffff;\n}\n.recipe-modal-container.ui.modal > .header .close.icon {\n  cursor: pointer;\n}\n.recipe-modal-container.ui.modal > .content {\n  padding: 0;\n  max-height: 80vh;\n  overflow: auto;\n  min-height: 400px;\n  background-color: white;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/managemenu/recipeModal.less
// module id = 3593
// module chunks = 0